
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M36 0c2.2 0 4 1.8 4 4v24c0 2.2-1.8 4-4 4H4c-2.2 0-4-1.8-4-4L.02 4C.02 1.8 1.8 0 4 0h32zm.429 7.619V3.556L20.358 13.715 4.287 3.556v4.063l16.071 10.159L36.429 7.619z"}})])
          )
        }
      }
    